<template>
  <b-modal
    id="add-new-client"
    size="xl"
    title="Новый клиент"
    hide-footer
    no-close-on-backdrop
  >
    <!-- <pre>
     {{localRequisites}}
   </pre> -->
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      shape="square"
      finish-button-text="Сохранить"
      back-button-text="Назад"
      next-button-text="Далее"
      @on-complete="formSubmitted"
    >

      <tab-content
        title="Общая информация о клиенте"
        :before-change="validationInfoClient"
      >
        <validation-observer
          ref="infoClient"
          tag="form"
        >
          <b-row>
            <b-col md="4">
              <h6 class="text-bold">
                Информация о компании
              </h6>
              <b-row class="mt-2">
                <b-col md="12">
                  <b-form-group
                    label="Клиент*"
                    label-for="name"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="title"
                      rules="required"
                    >
                      <b-form-input
                        id="name"
                        v-model="client.title"
                        size="lg"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    label="Описание"
                    label-for="email"
                  >
                    <b-form-textarea
                      id="textarea-default"
                      v-model="client.description"
                      rows="2"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="8">
                  <b-form-group
                    label="E-mail"
                    label-for="email"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="username"
                      rules="email"
                    >
                      <b-form-tags
                        v-model="clientEmails"
                        placeholder="Добавить"
                        input-id="tags-basic"
                        class="mb-2"
                        add-button-text="Новый"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="4">

                  <b-form-group
                    label="Статус"
                    label-for="status"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="username"
                      rules="required"
                    >
                      <b-form-group>
                        <v-select
                          v-model="client.status_of_client"
                          label="title"
                          :reduce="status => status.id"
                          :options="statusesclient"
                        />
                      </b-form-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                </b-col>
                <b-col md="12">
                  <label for="">Телефон</label>
                  <b-form-tags
                    v-model="clientPhones"
                    placeholder="Добавить"
                    input-id="tags-basic"
                    class="mb-2"
                    add-button-text="Новый"
                  />
                </b-col>

              </b-row>
            </b-col>

            <b-col md="4">
              <h6 class="text-bold">
                Агенты
              </h6>
              <b-row class="mt-2">
                <b-col md="12">
                  <b-form-group
                    label="ФИО*"
                    label-for="email"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="ФИО"
                      rules="required"
                    >
                      <b-form-input
                        id="name"
                        v-model="agent.name"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  md="12"
                  class="mt-50"
                >
                  <b-form-group

                    label-for="email"
                  >

                    <b-form-checkbox
                      v-model="agent.is_chief"
                    >
                      Руководитель
                    </b-form-checkbox>
                  </b-form-group>

                </b-col>

                <b-col
                  md="12"
                  class="mt-2"
                >
                  <label
                    class="mt-50"
                    for=""
                  >Номер телефона агента</label>
                  <b-form-tags
                    v-model="agentPhones"
                    placeholder="Добавить"
                    input-id="tags-basic"
                    class="mb-2"
                    add-button-text="Новый"
                  />
                </b-col>
              </b-row>
            </b-col>

            <b-col md="4">
              <h6 class="text-bold">
                Паспортные данные
              </h6>
              <b-row class="mt-2">
                <b-col
                  cols="12"
                  class="border__right"
                >
                  <b-form-group
                    label="Тип паспорта:"
                    label-for="email"
                  >
                    <div class="d-flex align-items-center mt-50">
                      <b-form-radio
                        v-model="passport_is_new"
                        class="mb-2"
                        name="some-radios"
                        :value="false"
                      >
                        Старый
                      </b-form-radio>

                      <b-form-radio
                        v-model="passport_is_new"
                        class="mb-2 ml-4"
                        name="some-radios"
                        :value="true"
                      >
                        Новое
                      </b-form-radio>
                    </div>
                  </b-form-group>

                  <span v-if="!passport_is_new">
                    <b-row>
                      <b-col md="4">
                        <b-form-group
                          label="Серия*"
                          label-for="seria"
                        >
                          <validation-provider
                            #default="{ errors }"
                            rules="required|length:2"
                            name="'Серия паспорта'"
                          >

                            <b-form-input
                              id="seria"
                              v-model="passport.seria"
                              placeholder="AB"
                              class="passport__style"
                              type="text"
                              :trim="true"
                            />

                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>

                      <b-col md="8">

                        <b-form-group
                          label="Номер паспорта*"
                          label-for="number-passport"
                          style="width: 100%"
                        >
                          <validation-provider
                            #default="{ errors }"
                            rules="required|length:7"
                            name="'Номер паспорта'"
                          >
                            <b-form-input
                              id="number-passport"
                              v-model="passport.number"
                              class="w-100"
                              placeholder="1234567"
                              type="number"
                              :trim="true"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>

                      </b-col>
                    </b-row>
                  </span>

                  <span v-else>
                    <b-form-group
                      label="ID*"
                      label-for="Id"
                    >
                      <validation-provider
                        #default="{ errors }"
                        rules="required|length:7"
                        name="ID паспорта"
                      >
                        <b-form-input
                          id="basicInput"
                          v-model="passport.id"
                          placeholder="ID"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </span>

                  <b-row>
                    <b-col md="6">
                      <b-form-group
                        label="Дата выдачи*"
                        label-for="passport_given_date"
                      >
                        <validation-provider
                          #default="{ errors }"
                          rules="required"
                          name="'Дата выдачи'"
                        >
                          <flat-pickr
                            v-model="agent.passport.passport_given_date"
                            class="form-control"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col md="6">
                      <b-form-group
                        label="Срок действия*"
                        label-for="passport_expire_date"
                      >
                        <validation-provider
                          #default="{ errors }"
                          rules="required"
                          name="'Срок действия'"
                        >
                          <flat-pickr
                            v-model="agent.passport.passport_expire_date"
                            class="form-control"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-form-group
                    label="Кем выдан*"
                    label-for="issued-by"
                    style="width: 100%"
                  >
                    <validation-provider
                      #default="{ errors }"
                      rules="required"
                      name="'Кем выдан'"
                    >
                      <b-form-textarea
                        id="issued-by"
                        v-model="agent.passport.passport_given_by"
                        class="w-100"
                        placeholder="Кем выдан"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                </b-col>
              </b-row>
            </b-col>

          </b-row>
        </validation-observer>
      </tab-content>

      <tab-content
        title="Реквизиты компании"
        :before-change="validationAdditionalInfoClient"
      >
        <validation-observer
          ref="validationAdditionalInfoClient"
          tag="form"
        >
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Юридический адррес"
                label-for="name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="address"
                  rules="required"
                >
                  <b-form-input
                    id="address"
                    v-model="client.address"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                label="ИНН"
                label-for="name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="INN"
                  rules="required|length:9"
                >
                  <b-form-input
                    id="name"
                    v-model="client.inn"
                    type="number"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="ОКЕД"
                label-for="name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="OKED"
                  rules="required|length:5"
                >
                  <b-form-input
                    id="name"
                    v-model="client.oked"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Код НДС"
                label-for="name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="username"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="client.code_nds"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

          </b-row>
        </validation-observer>
      </tab-content>

      <tab-content
        title="Банковские реквизиты"
      >

        <b-form-group
          label="Тип банковского реквизита"
          label-for="email"
        >
          <div class="d-flex align-items-center mt-50">
            <b-form-radio
              v-model="bank_requisite_type"
              class="mb-2"
              name="some-radios"
              :value="false"
            >
              Внутренний
            </b-form-radio>

            <b-form-radio
              v-model="bank_requisite_type"
              class="mb-2 ml-4"
              name="some-radios"
              :value="true"
            >
              Внешний
            </b-form-radio>
          </div>
        </b-form-group>

        <b-row v-if="!bank_requisite_type">
          <b-col md="4">
            <b-form-group
              label="Банк"
              label-for="item-name"
            >
              <b-form-input
                id="item-name"
                v-model="localRequisites.bank"
                type="text"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              label="Расчетный счет"
              label-for="item-name"
            >
              <b-form-input
                id="item-name"
                v-model="localRequisites.checking_account"
                type="text"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              label="МФО"
              label-for="item-name"
            >
              <b-form-input
                id="item-name"
                v-model="localRequisites.mfo"
                type="text"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-else>
          <b-col md="4">
            <b-form-group
              label="Банк"
              label-for="item-name"
            >
              <b-form-input
                id="item-name"
                v-model="internalRequisites.bank"
                type="text"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              label="Acc"
              label-for="item-name"
            >
              <b-form-input
                id="item-name"
                v-model="internalRequisites.checking_account"
                type="text"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              label="SWIFT"
              label-for="item-name"
            >
              <b-form-input
                id="item-name"
                v-model="internalRequisites.mfo"
                type="text"
              />
            </b-form-group>
          </b-col>
        </b-row>

      </tab-content>
    </form-wizard>

  </b-modal>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BFormTextarea,
  BFormTags,
  BFormRadio,
  BFormCheckbox,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import { required } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTags,
    BFormCheckbox,
    vSelect,
    BModal,
    BFormTextarea,
    BFormRadio,
    flatPickr,
  },
  props: ['statusesclient'],
  data() {
    return {
      required,
      passport_is_new: false,
      bank_requisite_type: false,
      passport: {},

      clientPhones: [],
      clientEmails: [],

      agentPhones: [],

      client: {
        title: 'dasda',
        description: '',
        phones: {},
        emails: {},
        status_of_client: null,
        inn: '',
        oked: '',
        address: '',
        code_nds: '',
        requisites: [],
      },
      agent: {
        name: '',
        // position: '',
        is_chief: false,
        phones: [],
        passport: {
          passport_given_by: '',
          passport_given_date: null,
          passport_expire_date: null,
        },
      },

      localRequisites: {
        bank: '',
        mfo: '',
        checking_account: '',
      },
      internalRequisites: {
        bank: '',
        mfo: '',
        checking_account: '',
        type: 'internal',
      },

    }
  },
  watch: {
    clientPhones(newVal) {
      const phones = {}
      newVal.forEach((phone, index) => {
        phones[index] = phone
      })

      this.client.phones = phones
    },
    clientEmails(newVal) {
      const emails = {}
      newVal.forEach((phone, index) => {
        emails[index] = phone
      })

      this.client.emails = emails
    },
    agentPhones(newVal) {
      const phones = {}
      newVal.forEach((phone, index) => {
        phones[index] = phone
      })

      this.agent.phones = phones
    },
    passport_is_new() {
      this.passport = {}
    },
  },
  methods: {
    ...mapActions('clients', ['GET_STATUS_CLIENT', 'ADD_NEW_CLIENT', 'FETCH_CLIENTS_LIST']),

    async formSubmitted() {
      if (!this.bank_requisite_type) {
        this.client.requisites = [{
          type: 'local',
          bank_requisite: this.localRequisites,
        }]
      } else {
        this.client.requisites = [{
          type: 'internal',
          bank_requisite: this.internalRequisites,
        }]
      }

      this.agent.passport = {
        ...this.agent.passport,
        ...this.passport,
      }

      await this.ADD_NEW_CLIENT({
        ...this.client,
        employee: [this.agent],
        entity: 'yuridiskiy',
      })

      this.passport_is_new = false

      this.clientPhones = []
      this.clientEmails = []

      this.agentPhones = []

      this.bank_requisite = []
      this.client = {
        title: '',
        description: '',
        phones: {},
        emails: {},
        status_of_client: null,
        inn: '',
        oked: '',
        address: '',
        code_nds: '',
        requisite: [],
      }
      this.agent = {
        name: '',
        position: '',
        is_chief: false,
        phones: [],
        passport: {
          number: '',
          seria: '',
          passport_given_by: '',
          passport_given_date: null,
          passport_expire_date: null,
        },
      }

      this.$nextTick(() => {
        this.$bvModal.hide('add-new-client')
      })

      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Form Submitted',
          icon: 'EditIcon',
          variant: 'success',
        },
      })
    },
    validationInfoClient() {
      return new Promise((resolve, reject) => {
        this.$refs.infoClient.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationAdditionalInfoClient() {
      return new Promise((resolve, reject) => {
        this.$refs.validationAdditionalInfoClient.validate().then(success => {
          // console.log(12313)
          // resolve(true)
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
  },
  computed: {
    ...mapGetters('clients', ['getStatusClient']),
    // statusesclient() {
    //   return this.getStatusClient.results.map(status => {
    //     return {
    //       id: status.id,
    //       title: status.title.ru
    //     }
    //   })
    // }
  },
}
</script>

<style lang="scss" >

.box-shadow {
    box-shadow: none;
}
@import '@core/scss/vue/libs/vue-wizard.scss';
 .wizard-header {
    padding: 0;
    margin: 0;
 }
 .vue-form-wizard {
    box-shadow: none;
    padding: 0;
 }
</style>
